import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/data/site";
import Logo from "@/components/Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-slate-200 bg-white"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-4">
        <div className="lg:col-span-2 space-y-5">
          <Logo />
          <p className="max-w-md text-sm leading-relaxed text-slate-500">
            {COMPANY.legalName} is a Dubai-based technology trading and
            solutions company supplying computers, IT hardware, electronic
            components and networking equipment to businesses across
            international markets.
          </p>
          <div className="flex items-center gap-3 pt-1">
            <a
              data-testid="footer-linkedin"
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-slate-200 text-slate-700 transition-colors hover:border-cyan-600/70 hover:text-cyan-700"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-600">
            Navigate
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-slate-700 transition-colors hover:text-cyan-700"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-600">
            Contact
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-700">
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 text-cyan-600" />
              <span>
                {COMPANY.address.line1}
                <br />
                {COMPANY.address.line2}
                <br />
                {COMPANY.address.city}, {COMPANY.address.country}
              </span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 text-cyan-600" />
              <a
                href={`tel:${COMPANY.phone}`}
                data-testid="footer-phone"
                className="hover:text-cyan-700"
              >
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 text-cyan-600" />
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email"
                className="hover:text-cyan-700"
              >
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-5 py-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:px-8">
          <span data-testid="footer-copy">
            © {year} {COMPANY.legalName}. All rights reserved.
          </span>
          <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-slate-500">
            DUBAI · UAE · IFZA
          </span>
        </div>
      </div>
    </footer>
  );
}
